// WebKit only honours clipboard writes issued inside the user gesture's own task, so a
// caller that must fetch the text first hands in a promise: the ClipboardItem form lets
// Safari accept the write at gesture time and resolve the payload later. Browsers without
// ClipboardItem (Firefox) await the text and write within their transient-activation window.
export const copyToClipboard = (text: string | Promise<string>) => {
  if (typeof text === 'string') {
    return navigator.clipboard.writeText(text);
  }
  if (typeof ClipboardItem !== 'undefined') {
    return navigator.clipboard.write([
      new ClipboardItem({
        'text/plain': text.then(value => new Blob([value], { type: 'text/plain' })),
      }),
    ]);
  }
  return text.then(value => navigator.clipboard.writeText(value));
};
